'use strict';

module.exports = require('./lib/ReactDOMServer');



//////////////////
// WEBPACK FOOTER
// ../~/react-dom/server.js
// module id = 434
// module chunks = 2